import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.index-of.js";
import "core-js/modules/es.symbol.description.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
import "core-js/modules/es.string.trim.js";
import "core-js/modules/es.array.find.js";
import _slicedToArray from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import { adjustServerTimestamp } from "@dp/common";
import i18next from "i18next";
import moment from "moment-timezone";
var SORTING_RULE;

(function (SORTING_RULE) {
  SORTING_RULE[SORTING_RULE["DEFAULT"] = 0] = "DEFAULT";
  SORTING_RULE[SORTING_RULE["BY_COLLAPSIBLE"] = 1] = "BY_COLLAPSIBLE";
  SORTING_RULE[SORTING_RULE["BY_MANDATORY"] = 2] = "BY_MANDATORY";
  SORTING_RULE[SORTING_RULE["BY_IN_PLACE"] = 3] = "BY_IN_PLACE";
})(SORTING_RULE || (SORTING_RULE = {}));

var SHOW_IMAGE;

(function (SHOW_IMAGE) {
  SHOW_IMAGE[SHOW_IMAGE["DEFAULT"] = 0] = "DEFAULT";
  SHOW_IMAGE[SHOW_IMAGE["DONOT_SHOW_IMAGES"] = 1] = "DONOT_SHOW_IMAGES";
  SHOW_IMAGE[SHOW_IMAGE["DONT_SHOW_FOR_COLLAPSED"] = 2] = "DONT_SHOW_FOR_COLLAPSED";
})(SHOW_IMAGE || (SHOW_IMAGE = {}));

var DEFAULT_TEMP_SLIDER_TEXT = ["Temperature Choice", "Temperatures", "Steak Temp"];
var DEFAULT_REMOVE_OPTION_PREFIX = "No ";
var ORDER_TYPE;

(function (ORDER_TYPE) {
  ORDER_TYPE[ORDER_TYPE["TOGO_PICKUP"] = 0] = "TOGO_PICKUP";
  ORDER_TYPE[ORDER_TYPE["GIFT_CARD"] = 1] = "GIFT_CARD";
  ORDER_TYPE[ORDER_TYPE["CATERING_DELIVERY"] = 2] = "CATERING_DELIVERY";
  ORDER_TYPE[ORDER_TYPE["CATERING_PICKUP"] = 3] = "CATERING_PICKUP";
  ORDER_TYPE[ORDER_TYPE["ORDER_AHEAD"] = 5] = "ORDER_AHEAD";
})(ORDER_TYPE || (ORDER_TYPE = {}));

var REORDER_ADD_BUTTON_TYPES;

(function (REORDER_ADD_BUTTON_TYPES) {
  REORDER_ADD_BUTTON_TYPES["PLUS"] = "PLUS";
  REORDER_ADD_BUTTON_TYPES["TEXT"] = "TEXT";
  REORDER_ADD_BUTTON_TYPES["ROUND"] = "ROUND";
})(REORDER_ADD_BUTTON_TYPES || (REORDER_ADD_BUTTON_TYPES = {}));

var SHOW_TEMP_DESCRIPTION;

(function (SHOW_TEMP_DESCRIPTION) {
  SHOW_TEMP_DESCRIPTION[SHOW_TEMP_DESCRIPTION["HIDE"] = 0] = "HIDE";
  SHOW_TEMP_DESCRIPTION[SHOW_TEMP_DESCRIPTION["SHOW"] = 1] = "SHOW";
})(SHOW_TEMP_DESCRIPTION || (SHOW_TEMP_DESCRIPTION = {}));

var MENU_SEARCH_SORTING_RULE;
/**
 * The brand specific rules schema.
 * Schema is used to provide any brand specific code customization in a declarative way.
 * TODO: provide server override
 * */

(function (MENU_SEARCH_SORTING_RULE) {
  MENU_SEARCH_SORTING_RULE[MENU_SEARCH_SORTING_RULE["SORT_TITLE_ALPHABETICALLY"] = 0] = "SORT_TITLE_ALPHABETICALLY";
  MENU_SEARCH_SORTING_RULE[MENU_SEARCH_SORTING_RULE["SORT_NATURAL"] = 1] = "SORT_NATURAL";
  MENU_SEARCH_SORTING_RULE[MENU_SEARCH_SORTING_RULE["SORT_KEYWORD_POSITION"] = 2] = "SORT_KEYWORD_POSITION";
})(MENU_SEARCH_SORTING_RULE || (MENU_SEARCH_SORTING_RULE = {}));

var _OVERRIDE_SCHEMA = {
  OG: {
    showPDFMenu: true,
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    showImage: SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "classic-entrees",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_DELIVERY, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.HIDE,
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: true,
    showRequiredLabel: true,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: false,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: false,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.PLUS,
    isImageDisplayed: true,
    PRICING_FORMAT: "$xx.xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    hideLegalDisclaimer: false,
    showTemperatureSelectionDescriptionValuesFromAPI: false,
    shouldShowFirstCategoryByDefault: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: false,
    brandSpecificProduct: "breadsticks",
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: null,
    hideBGImageOnAccountScreens: false,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: null
  },
  LH: {
    showPDFMenu: true,
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    removeOptionPrefix: "No ",
    showImage: SHOW_IMAGE.DEFAULT,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "legendary-steaks-combos",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    hideCalorieDataOnMenuList: true,
    alwaysShowOrderType: false,
    showRequiredLabel: true,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: true,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: true,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: false,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.PLUS,
    isImageDisplayed: true,
    PRICING_FORMAT: "$xx.xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: false,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: true,
    temperatureSelectionWarning: [{
      on: "Medium Well",
      to: "Medium"
    }, {
      on: "Well Done",
      to: "Medium Well"
    }],
    showReservationsTopTabs: false,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: null,
    hideBGImageOnAccountScreens: true,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: false,
    joinEclubMobileSMSUrl: null
  },
  CS: {
    showPDFMenu: true,
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.DEFAULT,
    temperatureSliderText: ["Temperature Choice", "Steak Temp"],
    showImage: SHOW_IMAGE.DEFAULT,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "family-bundles",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showListWithCarousels: true,
    showTwoColumns: false,
    showRequiredLabel: false,
    FILTER_OUT_REDUNDANT_OPTIONS: true,
    showListItemCollapsedByRequired: true,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: true,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.PLUS,
    isImageDisplayed: true,
    PRICING_FORMAT: "$xx.xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    showTemperatureSelectionDescriptionValuesFromAPI: false,
    shouldShowFirstCategoryByDefault: false,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    brandSpecificProduct: "croissants",
    showReservationsTopTabs: false,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: null,
    hideBGImageOnAccountScreens: false,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: "https://703ca285-c67d-4e0c-8e60-951712d1381f.trayapp.io/?shortcode=79922&keyword=JOIN&fallback=https://m.cheddars.com"
  },
  EV: {
    showPDFMenu: false,
    showDefaultSeatingOptionsMessage: true,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    showImage: SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "dinner",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_DELIVERY, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showRequiredLabel: true,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: false,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: true,
    isImageDisplayed: false,
    showCircularAddButton: true,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.ROUND,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: true,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: false,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: false,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: "/private-dining",
    hideBGImageOnAccountScreens: true,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: false,
    joinEclubMobileSMSUrl: null
  },
  CB: {
    showPDFMenu: false,
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    showImage: SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED,
    temperatureSliderText: ["Burger Temperature", "Steak Temperature"],
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "food",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_DELIVERY, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showRequiredLabel: false,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: false,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: false,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.TEXT,
    isImageDisplayed: false,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: true,
    hideLegalDisclaimer: false,
    headerImage: true,
    showRecommendationsTab: false,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: false,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: false,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    isMenuListingAddCTARound: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: null,
    hideBGImageOnAccountScreens: true,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: false,
    joinEclubMobileSMSUrl: null
  },
  BB: {
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    showImage: SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED,
    isCollapsedKey: "isCollapsible",
    temperatureSliderText: ["Temperature Choice", "Steak Temp", "Temperature"],
    defaultCategoryCode: "food",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.HIDE,
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showRequiredLabel: true,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: false,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: true,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.TEXT,
    isImageDisplayed: true,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "$xx.xx",
    showBgCoverImage: true,
    categoryGradientBg: true,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: true,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: true,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 1000,
    displayComplimentaryItemsOptionsBelow: true,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: true,
    hideBGImageOnAccountScreens: false,
    privateDiningURLPath: "/group-dining",
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: null
  },
  YH: {
    showPDFMenu: false,
    showDefaultSeatingOptionsMessage: false,
    sort: SORTING_RULE.BY_COLLAPSIBLE,
    showImage: SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "eat",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_DELIVERY, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    temperatureSliderText: ["Temperature:"],
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showRequiredLabel: true,
    FILTER_OUT_REDUNDANT_OPTIONS: false,
    showListItemCollapsedByRequired: false,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: false,
    showCircularAddButton: true,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.TEXT,
    isImageDisplayed: true,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "xx.xx",
    showBgCoverImage: false,
    categoryGradientBg: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: true,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: true,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 10,
    displayComplimentaryItemsOptionsBelow: true,
    isGroupDiningSupported: true,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    hideBGImageOnAccountScreens: false,
    privateDiningURLPath: "/group-dining",
    restaurantsThatSupport10Guests: ["8389"],
    showAdditionalMenuForPD: ["8389"],
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: null
  },
  CG: {
    showPDFMenu: false,
    showDefaultSeatingOptionsMessage: true,
    sort: SORTING_RULE.DEFAULT,
    temperatureSliderText: ["Temperature Choice", "Steak Temp", "Temperature"],
    showImage: SHOW_IMAGE.DEFAULT,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "lunch",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showListWithCarousels: true,
    showTwoColumns: false,
    showRequiredLabel: false,
    FILTER_OUT_REDUNDANT_OPTIONS: true,
    showListItemCollapsedByRequired: true,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    categoryGradientBg: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: false,
    showCircularAddButton: true,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.ROUND,
    isImageDisplayed: false,
    PRICING_FORMAT: "xx",
    showBgCoverImage: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: true,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: false,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: false,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: true,
    showNutritionalInfo: false,
    showReservationsAsPrimaryButton: true,
    searchRestaurantsPageSize: 1000,
    displayComplimentaryItemsOptionsBelow: false,
    isGroupDiningSupported: false,
    wineListAvailableBrand: true,
    wineLockerAvailableBrand: true,
    bottomTabsContainReservations: true,
    mobileAppBottomTabsMenuStackLabel: "Menu",
    mobileAppLocationListShowsInternationalLocations: true,
    showInternationalPhoneOptionForPD: false,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: "/private-dining",
    hideBGImageOnAccountScreens: true,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: false,
    joinEclubMobileSMSUrl: null
  },
  S52: {
    showPDFMenu: true,
    showDefaultSeatingOptionsMessage: true,
    sort: SORTING_RULE.DEFAULT,
    temperatureSliderText: ["Temperature", "Temperature Choice", "Steak Temp", "Steak Temperature"],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    showImage: SHOW_IMAGE.DEFAULT,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "all-day",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showListWithCarousels: true,
    showTwoColumns: false,
    showRequiredLabel: false,
    FILTER_OUT_REDUNDANT_OPTIONS: true,
    showListItemCollapsedByRequired: true,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    categoryGradientBg: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: true,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.TEXT,
    isImageDisplayed: true,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "s52",
    showBgCoverImage: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: false,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    showReservationsTopTabs: true,
    showNutritionalInfo: true,
    showReservationsAsPrimaryButton: false,
    searchRestaurantsPageSize: 1000,
    displayComplimentaryItemsOptionsBelow: true,
    isGroupDiningSupported: false,
    wineListAvailableBrand: false,
    wineLockerAvailableBrand: false,
    bottomTabsContainReservations: false,
    mobileAppBottomTabsMenuStackLabel: "Menu & Order",
    mobileAppLocationListShowsInternationalLocations: false,
    showInternationalPhoneOptionForPD: true,
    reservationListTopBanner: false,
    isMenuListingAddCTARound: false,
    showExploreRestDetailsCTA: false,
    hideNutritionalInfoTextOnMenuItemDetails: false,
    showPdBackground: false,
    privateDiningURLPath: "/group-dining",
    hideBGImageOnAccountScreens: false,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    escapeKerrowLocationsFilterForLocationDropdown: false,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: null
  },
  RC: {
    showPDFMenu: true,
    showDefaultSeatingOptionsMessage: true,
    sort: SORTING_RULE.DEFAULT,
    temperatureSliderText: ["Temperature", "Temperature Choice", "Steak Temp", "Steak Temperature"],
    isTemperatureDescriptionVisible: SHOW_TEMP_DESCRIPTION.SHOW,
    showImage: SHOW_IMAGE.DEFAULT,
    isCollapsedKey: "isCollapsible",
    defaultCategoryCode: "steaks-chops",
    availableOrderTypes: [ORDER_TYPE.TOGO_PICKUP, ORDER_TYPE.CATERING_PICKUP, ORDER_TYPE.GIFT_CARD],
    hideCalorieDataOnMenuList: false,
    alwaysShowOrderType: false,
    showListWithCarousels: true,
    showTwoColumns: false,
    showRequiredLabel: false,
    FILTER_OUT_REDUNDANT_OPTIONS: true,
    showListItemCollapsedByRequired: true,
    COLLAPSE_MODIFIERS_IF_OPTIONAL: false,
    categoryGradientBg: false,
    DOES_SUPPORT_MENU_LIST_RECOMMENDATION: true,
    showCircularAddButton: false,
    reorderPageAddButtonType: REORDER_ADD_BUTTON_TYPES.TEXT,
    isImageDisplayed: true,
    EXTERNAL_LINK_SLUGS: [{
      slug: "happy-hour",
      url: "/menu-listing/happy-hour"
    }],
    PRICING_FORMAT: "xx",
    showBgCoverImage: false,
    showTemperatureSelectionDescriptionValuesFromAPI: true,
    shouldShowFirstCategoryByDefault: false,
    hideLegalDisclaimer: false,
    headerImage: false,
    showRecommendationsTab: true,
    menuSearchSortingType: MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY,
    showRecommendationsInSearch: true,
    supportLongMenuNamesWithPriceAlignment: false,
    temperatureSelectionWarning: [],
    searchRestaurantsPageSize: 1000,
    displayComplimentaryItemsOptionsBelow: true,
    isGroupDiningSupported: false,
    reservationListTopBanner: true,
    isMenuListingAddCTARound: true,
    showExploreRestDetailsCTA: true,
    hideNutritionalInfoTextOnMenuItemDetails: true,
    showPdBackground: false,
    hideBGImageOnAccountScreens: false,
    restaurantsThatSupport10Guests: null,
    showAdditionalMenuForPD: null,
    privateDiningURLPath: "/private-events",
    escapeKerrowLocationsFilterForLocationDropdown: true,
    showBackgroundBuildingImage: true,
    joinEclubMobileSMSUrl: null
  }
};
/*==================================== IMPLEMENTATION =============================*/

var BrandRules = /*#__PURE__*/function () {
  function BrandRules(_brand) {
    _classCallCheck(this, BrandRules);

    _defineProperty(this, "_brand", void 0);

    this._brand = _brand;
  }

  _createClass(BrandRules, [{
    key: "sortMenuSearchResults",
    value: function sortMenuSearchResults(matchedItems, searchText) {
      var _OVERRIDE_SCHEMA$this;

      var brandMenuSearchSortRule = (_OVERRIDE_SCHEMA$this = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this === void 0 ? void 0 : _OVERRIDE_SCHEMA$this.menuSearchSortingType;

      if (brandMenuSearchSortRule === MENU_SEARCH_SORTING_RULE.SORT_NATURAL) {
        var sortedMatchedItems = matchedItems === null || matchedItems === void 0 ? void 0 : matchedItems.sort(function (a, b) {
          return a.positionalIndex - b.positionalIndex;
        });
        return sortedMatchedItems;
      } else if (brandMenuSearchSortRule === MENU_SEARCH_SORTING_RULE.SORT_TITLE_ALPHABETICALLY) {
        var _sortedMatchedItems = matchedItems === null || matchedItems === void 0 ? void 0 : matchedItems.sort(this._itemComparator);

        return _sortedMatchedItems;
      } else {
        var _sortedMatchedItems2 = this._sortMenuSearchItemByKeywordPosition(matchedItems, searchText);

        return _sortedMatchedItems2;
      }
    }
  }, {
    key: "_itemComparator",
    value: function _itemComparator(a, b) {
      var _a$name, _b$name, _a$name2, _b$name2;

      if ((a === null || a === void 0 ? void 0 : (_a$name = a.name) === null || _a$name === void 0 ? void 0 : _a$name.toLowerCase()) < (b === null || b === void 0 ? void 0 : (_b$name = b.name) === null || _b$name === void 0 ? void 0 : _b$name.toLowerCase())) {
        return -1;
      }

      if ((a === null || a === void 0 ? void 0 : (_a$name2 = a.name) === null || _a$name2 === void 0 ? void 0 : _a$name2.toLowerCase()) > (b === null || b === void 0 ? void 0 : (_b$name2 = b.name) === null || _b$name2 === void 0 ? void 0 : _b$name2.toLowerCase())) {
        return 1;
      } else {
        return (b === null || b === void 0 ? void 0 : b.price) - (a === null || a === void 0 ? void 0 : a.price);
      }
    }
  }, {
    key: "_sortMenuSearchItemByKeywordPosition",
    value: function _sortMenuSearchItemByKeywordPosition(matchedItems, searchText) {
      var multiplier = {
        title: 10000,
        description: 100
      };
      var fixedLengthValue = 250;
      var matchedItemsArray = [];
      var length = matchedItems.length;

      for (var i = 0; i < length; i++) {
        var item = matchedItems[i];
        var titleMultiplier = item.name.toLowerCase().indexOf(searchText) >= 0 ? multiplier.title * (fixedLengthValue - item.name.toLowerCase().indexOf(searchText)) : 0;
        var descMultiplier = item.description && item.description.toLowerCase().indexOf(searchText) >= 0 ? multiplier.description * (fixedLengthValue - item.description.toLowerCase().indexOf(searchText)) : 0;

        var keywordMultiplier = this._calculateKeywordMultiplier(item, searchText);

        var rank = titleMultiplier + descMultiplier + keywordMultiplier;
        item = _objectSpread(_objectSpread({}, item), {}, {
          rank: rank
        });
        matchedItemsArray.push(item);
      }

      return matchedItemsArray.sort(function (a, b) {
        return b.rank - a.rank;
      });
    }
  }, {
    key: "_calculateKeywordMultiplier",
    value: function _calculateKeywordMultiplier(item, searchText) {
      var keywordMultiplier = 1;
      var rank = 0;
      var length = item.keywords.length;

      for (var i = 0; i < length; i++) {
        if (item.keywords[i].toLowerCase().indexOf(searchText.toLowerCase()) !== -1) {
          rank = rank + keywordMultiplier * (length - i);
          break;
        }
      }

      return rank;
    }
  }, {
    key: "isTemperatureSlider",
    value: function isTemperatureSlider(optionName) {
      var _OVERRIDE_SCHEMA$this2;

      var brandTemperatureSliderRule = (_OVERRIDE_SCHEMA$this2 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this2 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this2.temperatureSliderText;

      if (!brandTemperatureSliderRule) {
        return DEFAULT_TEMP_SLIDER_TEXT.indexOf(optionName) !== -1;
      } else {
        return brandTemperatureSliderRule.indexOf(optionName) !== -1;
      }
    }
  }, {
    key: "isTemperatureDescriptionVisible",
    value: function isTemperatureDescriptionVisible() {
      var _OVERRIDE_SCHEMA$this3;

      return (_OVERRIDE_SCHEMA$this3 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this3 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this3.isTemperatureDescriptionVisible;
    }
  }, {
    key: "getOptionName",
    value: function getOptionName(option) {
      if (option.optionType === "No") {
        return this.parseDescription(option.description || option.name); // to fix no Ice
      } else return option.description || option.name;
    }
  }, {
    key: "getFilteredOutRedundantOptions",
    value: function getFilteredOutRedundantOptions(sortedProperties) {
      if (_OVERRIDE_SCHEMA[this._brand].FILTER_OUT_REDUNDANT_OPTIONS) {
        var _sortedProperties;

        sortedProperties = (_sortedProperties = sortedProperties) === null || _sortedProperties === void 0 ? void 0 : _sortedProperties.filter(function (property) {
          var _property$options, _property$options$;

          if (property !== null && property !== void 0 && property.required && (property === null || property === void 0 ? void 0 : (_property$options = property.options) === null || _property$options === void 0 ? void 0 : _property$options.length) === 1 && property !== null && property !== void 0 && (_property$options$ = property.options[0]) !== null && _property$options$ !== void 0 && _property$options$.isSelected) {
            return false;
          }

          return property;
        });
      }

      return sortedProperties;
    }
  }, {
    key: "getSelectedOptionDescription",
    value: function getSelectedOptionDescription(selectedSubOptions) {
      var _selectedSubOptions$m,
          _this = this;

      return selectedSubOptions === null || selectedSubOptions === void 0 ? void 0 : (_selectedSubOptions$m = selectedSubOptions.map(function (selectedOpt) {
        var _OVERRIDE_SCHEMA$_thi, _OVERRIDE_SCHEMA$_thi2;

        var optionType = selectedOpt.optionType;
        var removeOptionPrefix = (_OVERRIDE_SCHEMA$_thi = (_OVERRIDE_SCHEMA$_thi2 = _OVERRIDE_SCHEMA[_this._brand]) === null || _OVERRIDE_SCHEMA$_thi2 === void 0 ? void 0 : _OVERRIDE_SCHEMA$_thi2.removeOptionPrefix) !== null && _OVERRIDE_SCHEMA$_thi !== void 0 ? _OVERRIDE_SCHEMA$_thi : DEFAULT_REMOVE_OPTION_PREFIX;
        return (optionType === "No" ? removeOptionPrefix : "") + _this.getOptionName(selectedOpt); //May be a brand Rule candidate
      })) === null || _selectedSubOptions$m === void 0 ? void 0 : _selectedSubOptions$m.join(", ");
    }
  }, {
    key: "parseDescription",
    value: function parseDescription(description) {
      try {
        if (!description) return "";
        return this._removeExtraNo(description);
      } catch (e) {
        return description;
      }
    }
  }, {
    key: "_removeExtraNo",
    value: function _removeExtraNo(str) {
      var _f$trim;

      var _darr = str === null || str === void 0 ? void 0 : str.split(" ");

      var _f = _darr ? _darr[0] : "";

      if ((_f === null || _f === void 0 ? void 0 : (_f$trim = _f.trim()) === null || _f$trim === void 0 ? void 0 : _f$trim.toLocaleLowerCase()) === "no") {
        _darr.shift();

        return _darr.join("");
      }

      return str;
    }
  }, {
    key: "cartCustomizationName",
    value: function cartCustomizationName(name, optionType) {
      if (optionType) {
        if (optionType === "Everything" || optionType === "Confirm") return name;
        return optionType + " " + this._removeExtraNo(name);
      }

      return name;
    }
  }, {
    key: "showMenuImages",
    value: function showMenuImages(propertyOption) {
      var _OVERRIDE_SCHEMA$this4, _propertyOption$optio;

      var collapsed = propertyOption === null || propertyOption === void 0 ? void 0 : propertyOption.isCollapsible;
      var showImageBrand = (_OVERRIDE_SCHEMA$this4 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this4 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this4.showImage;
      var showImage = true;

      if (showImageBrand === SHOW_IMAGE.DONT_SHOW_FOR_COLLAPSED && collapsed) {
        showImage = false;
      }

      if (showImageBrand === SHOW_IMAGE.DONOT_SHOW_IMAGES) {
        showImage = false;
      }

      var atleastOneImage = (propertyOption === null || propertyOption === void 0 ? void 0 : (_propertyOption$optio = propertyOption.options) === null || _propertyOption$optio === void 0 ? void 0 : _propertyOption$optio.filter(function (opt) {
        return opt.thumbnailImage;
      }).length) > 0;

      if (!atleastOneImage) {
        showImage = false;
      }

      return showImage;
    }
  }, {
    key: "getDefaultCategoryCode",
    value: function getDefaultCategoryCode(lunchSlot, currentTime, isDipo) {
      var _OVERRIDE_SCHEMA$this5;

      if (this._brand === "S52") {
        if (lunchSlot !== null && lunchSlot !== void 0 && lunchSlot.startDateTime && lunchSlot !== null && lunchSlot !== void 0 && lunchSlot.endDateTime && currentTime !== null && currentTime !== void 0 && currentTime.dateTime) {
          if (moment(adjustServerTimestamp(currentTime.dateTime)).isSameOrAfter(lunchSlot.startDateTime) && moment(adjustServerTimestamp(currentTime.dateTime)).isSameOrBefore(lunchSlot.endDateTime)) {
            return "lunch";
          }
        }
      }

      if (this._brand === "LH" && isDipo) {
        return "appetizers";
      }

      return ((_OVERRIDE_SCHEMA$this5 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this5 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this5.defaultCategoryCode) || null;
    }
  }, {
    key: "availableOrderTypes",
    value: function availableOrderTypes() {
      var _OVERRIDE_SCHEMA$this6;

      return (_OVERRIDE_SCHEMA$this6 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this6 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this6.availableOrderTypes;
    }
  }, {
    key: "getIfHideCaloriefDataOnMenuList",
    value: function getIfHideCaloriefDataOnMenuList() {
      var _OVERRIDE_SCHEMA$this7;

      return (_OVERRIDE_SCHEMA$this7 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this7 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this7.hideCalorieDataOnMenuList;
    }
  }, {
    key: "alwaysShowOrderType",
    value: function alwaysShowOrderType() {
      return _OVERRIDE_SCHEMA[this._brand].alwaysShowOrderType;
    }
  }, {
    key: "showListWithCarousels",
    value: function showListWithCarousels() {
      var _OVERRIDE_SCHEMA$this8;

      return ((_OVERRIDE_SCHEMA$this8 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this8 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this8.showListWithCarousels) || false;
    }
  }, {
    key: "showRequiredLabel",
    value: function showRequiredLabel() {
      var _OVERRIDE_SCHEMA$this9;

      return (_OVERRIDE_SCHEMA$this9 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this9 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this9.showRequiredLabel;
    }
  }, {
    key: "showTwoColumns",
    value: function showTwoColumns() {
      if ("showTwoColumns" in _OVERRIDE_SCHEMA[this._brand]) {
        return _OVERRIDE_SCHEMA[this._brand].showTwoColumns;
      }

      return true;
    }
  }, {
    key: "showListItemCollapsedByRequired",
    value: function showListItemCollapsedByRequired() {
      return _OVERRIDE_SCHEMA[this._brand].showListItemCollapsedByRequired;
    }
  }, {
    key: "collapseModifiersIfOptional",
    value: function collapseModifiersIfOptional() {
      return _OVERRIDE_SCHEMA[this._brand].COLLAPSE_MODIFIERS_IF_OPTIONAL;
    }
  }, {
    key: "categoryGradientBg",
    value: function categoryGradientBg() {
      var _OVERRIDE_SCHEMA$this10;

      return (_OVERRIDE_SCHEMA$this10 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this10 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this10.categoryGradientBg;
    }
  }, {
    key: "doesSupportMenuListRecommendation",
    value: function doesSupportMenuListRecommendation() {
      var _OVERRIDE_SCHEMA$this11;

      return (_OVERRIDE_SCHEMA$this11 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this11 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this11.DOES_SUPPORT_MENU_LIST_RECOMMENDATION;
    }
  }, {
    key: "shouldShowMenuRecommendationTab",
    value: function shouldShowMenuRecommendationTab() {
      var _OVERRIDE_SCHEMA$this12;

      return (_OVERRIDE_SCHEMA$this12 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this12 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this12.showRecommendationsTab;
    }
  }, {
    key: "showCircularAddToCartButton",
    value: function showCircularAddToCartButton() {
      return _OVERRIDE_SCHEMA[this._brand].showCircularAddButton;
    }
  }, {
    key: "isImageDisplayed",
    value: function isImageDisplayed() {
      var _OVERRIDE_SCHEMA$this13;

      return (_OVERRIDE_SCHEMA$this13 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this13 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this13.isImageDisplayed;
    }
  }, {
    key: "showBgCoverImage",
    value: function showBgCoverImage() {
      var _OVERRIDE_SCHEMA$this14;

      return (_OVERRIDE_SCHEMA$this14 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this14 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this14.showBgCoverImage;
    }
  }, {
    key: "brandSpecificProduct",
    value: function brandSpecificProduct() {
      var _OVERRIDE_SCHEMA$this15;

      return (_OVERRIDE_SCHEMA$this15 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this15 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this15.brandSpecificProduct;
    }
  }, {
    key: "externalLinkUrl",
    value: function externalLinkUrl(slug) {
      var _OVERRIDE_SCHEMA$this16, _OVERRIDE_SCHEMA$this17, _OVERRIDE_SCHEMA$this18;

      return (_OVERRIDE_SCHEMA$this16 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this16 === void 0 ? void 0 : (_OVERRIDE_SCHEMA$this17 = _OVERRIDE_SCHEMA$this16.EXTERNAL_LINK_SLUGS) === null || _OVERRIDE_SCHEMA$this17 === void 0 ? void 0 : (_OVERRIDE_SCHEMA$this18 = _OVERRIDE_SCHEMA$this17.find(function (slugObject) {
        return slugObject.slug === slug;
      })) === null || _OVERRIDE_SCHEMA$this18 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this18.url;
    }
  }, {
    key: "pricingFormat",
    value: function pricingFormat() {
      var _OVERRIDE_SCHEMA$this19;

      return (_OVERRIDE_SCHEMA$this19 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this19 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this19.PRICING_FORMAT;
    }
  }, {
    key: "getReoderPageAddButtonType",
    value: function getReoderPageAddButtonType() {
      var _OVERRIDE_SCHEMA$this20;

      return (_OVERRIDE_SCHEMA$this20 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this20 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this20.reorderPageAddButtonType;
    }
  }, {
    key: "shouldShowTemperatureSelectionDescriptionValuesFromAPI",
    value: function shouldShowTemperatureSelectionDescriptionValuesFromAPI() {
      var _OVERRIDE_SCHEMA$this21;

      return (_OVERRIDE_SCHEMA$this21 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this21 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this21.showTemperatureSelectionDescriptionValuesFromAPI;
    }
  }, {
    key: "shouldShowFirstCategoryByDefault",
    value: function shouldShowFirstCategoryByDefault() {
      var _OVERRIDE_SCHEMA$this22;

      return (_OVERRIDE_SCHEMA$this22 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this22 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this22.shouldShowFirstCategoryByDefault;
    }
  }, {
    key: "hideLegalDisclaimer",
    value: function hideLegalDisclaimer() {
      var _OVERRIDE_SCHEMA$this23;

      return (_OVERRIDE_SCHEMA$this23 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this23 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this23.hideLegalDisclaimer;
    }
  }, {
    key: "showPDFMenu",
    value: function showPDFMenu() {
      var _OVERRIDE_SCHEMA$this24;

      return (_OVERRIDE_SCHEMA$this24 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this24 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this24.showPDFMenu;
    }
  }, {
    key: "showDefaultSeatingOptionsMessage",
    value: function showDefaultSeatingOptionsMessage() {
      var _OVERRIDE_SCHEMA$this25;

      return (_OVERRIDE_SCHEMA$this25 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this25 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this25.showDefaultSeatingOptionsMessage;
    }
  }, {
    key: "showReservationsTopTabs",
    value: function showReservationsTopTabs() {
      var _OVERRIDE_SCHEMA$this26;

      return (_OVERRIDE_SCHEMA$this26 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this26 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this26.showReservationsTopTabs;
    }
  }, {
    key: "showReservationsAsPrimaryButton",
    value: function showReservationsAsPrimaryButton() {
      var _OVERRIDE_SCHEMA$this27;

      return (_OVERRIDE_SCHEMA$this27 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this27 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this27.showReservationsAsPrimaryButton;
    }
  }, {
    key: "showNutritionalInfo",
    value: function showNutritionalInfo() {
      var _OVERRIDE_SCHEMA$this28;

      return (_OVERRIDE_SCHEMA$this28 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this28 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this28.showNutritionalInfo;
    }
  }, {
    key: "isHeaderBackgroundImage",
    value: function isHeaderBackgroundImage() {
      var _OVERRIDE_SCHEMA$this29;

      return (_OVERRIDE_SCHEMA$this29 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this29 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this29.headerImage;
    }
  }, {
    key: "showRecommendationsInSearchModal",
    value: function showRecommendationsInSearchModal() {
      var _OVERRIDE_SCHEMA$this30;

      return (_OVERRIDE_SCHEMA$this30 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this30 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this30.showRecommendationsInSearch;
    }
  }, {
    key: "doesSupportMenuItemNameWith3Lines",
    value: function doesSupportMenuItemNameWith3Lines() {
      var _OVERRIDE_SCHEMA$this31;

      return (_OVERRIDE_SCHEMA$this31 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this31 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this31.supportLongMenuNamesWithPriceAlignment;
    }
  }, {
    key: "getTemperatureSelectionWarning",
    value: function getTemperatureSelectionWarning(optionName) {
      var _OVERRIDE_SCHEMA$this32, _OVERRIDE_SCHEMA$this33;

      var tempSliderWarningObjArray = (_OVERRIDE_SCHEMA$this32 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this32 === void 0 ? void 0 : (_OVERRIDE_SCHEMA$this33 = _OVERRIDE_SCHEMA$this32.temperatureSelectionWarning) === null || _OVERRIDE_SCHEMA$this33 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this33.filter(function (item) {
        return item.on === optionName;
      });

      var _tempSliderWarningObj = _slicedToArray(tempSliderWarningObjArray, 1),
          tempSliderWarningObj = _tempSliderWarningObj[0];

      if (tempSliderWarningObj) return {
        flag: true,
        to: tempSliderWarningObj === null || tempSliderWarningObj === void 0 ? void 0 : tempSliderWarningObj.to
      };
      return {
        flag: false,
        to: ""
      };
    }
  }, {
    key: "searchRestaurantsPageSize",
    value: function searchRestaurantsPageSize() {
      var _OVERRIDE_SCHEMA$this34;

      return +i18next.t("restaurant.resultsPerPage", {
        defaultValue: (_OVERRIDE_SCHEMA$this34 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this34 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this34.searchRestaurantsPageSize
      });
    }
  }, {
    key: "displayComplimentaryItemsOptionsBelow",
    value: function displayComplimentaryItemsOptionsBelow() {
      var _OVERRIDE_SCHEMA$this35;

      return (_OVERRIDE_SCHEMA$this35 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this35 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this35.displayComplimentaryItemsOptionsBelow;
    }
  }, {
    key: "isGroupDiningSupported",
    value: function isGroupDiningSupported() {
      var _OVERRIDE_SCHEMA$this36;

      return (_OVERRIDE_SCHEMA$this36 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this36 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this36.isGroupDiningSupported;
    }
  }, {
    key: "isWineListAvailable",
    value: function isWineListAvailable() {
      var _OVERRIDE_SCHEMA$this37;

      return (_OVERRIDE_SCHEMA$this37 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this37 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this37.wineListAvailableBrand;
    }
  }, {
    key: "isWineLockerAvailable",
    value: function isWineLockerAvailable() {
      var _OVERRIDE_SCHEMA$this38;

      return (_OVERRIDE_SCHEMA$this38 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this38 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this38.wineLockerAvailableBrand;
    }
  }, {
    key: "bottomTabsContainReservations",
    value: function bottomTabsContainReservations() {
      var _OVERRIDE_SCHEMA$this39;

      return (_OVERRIDE_SCHEMA$this39 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this39 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this39.bottomTabsContainReservations;
    }
  }, {
    key: "mobileAppBottomTabsMenuStackLabel",
    value: function mobileAppBottomTabsMenuStackLabel() {
      var _OVERRIDE_SCHEMA$this40;

      return (_OVERRIDE_SCHEMA$this40 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this40 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this40.mobileAppBottomTabsMenuStackLabel;
    }
  }, {
    key: "mobileAppLocationListShowsInternationalLocations",
    value: function mobileAppLocationListShowsInternationalLocations() {
      var _OVERRIDE_SCHEMA$this41;

      return (_OVERRIDE_SCHEMA$this41 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this41 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this41.mobileAppLocationListShowsInternationalLocations;
    }
  }, {
    key: "isInternationalPhoneOptionEnabledForPD",
    value: function isInternationalPhoneOptionEnabledForPD() {
      var _OVERRIDE_SCHEMA$this42;

      return (_OVERRIDE_SCHEMA$this42 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this42 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this42.showInternationalPhoneOptionForPD;
    }
  }, {
    key: "reservationListTopBanner",
    value: function reservationListTopBanner() {
      var _OVERRIDE_SCHEMA$this43;

      return (_OVERRIDE_SCHEMA$this43 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this43 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this43.reservationListTopBanner;
    }
  }, {
    key: "isMenuListingAddCTARound",
    value: function isMenuListingAddCTARound() {
      var _OVERRIDE_SCHEMA$this44;

      return (_OVERRIDE_SCHEMA$this44 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this44 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this44.isMenuListingAddCTARound;
    }
  }, {
    key: "showExploreRestDetailsCTA",
    value: function showExploreRestDetailsCTA() {
      var _OVERRIDE_SCHEMA$this45;

      return (_OVERRIDE_SCHEMA$this45 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this45 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this45.showExploreRestDetailsCTA;
    }
  }, {
    key: "hideNutritionalInfoTextOnMenuItemDetails",
    value: function hideNutritionalInfoTextOnMenuItemDetails() {
      var _OVERRIDE_SCHEMA$this46;

      return (_OVERRIDE_SCHEMA$this46 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this46 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this46.hideNutritionalInfoTextOnMenuItemDetails;
    }
  }, {
    key: "showPdBackground",
    value: function showPdBackground() {
      var _OVERRIDE_SCHEMA$this47;

      return (_OVERRIDE_SCHEMA$this47 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this47 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this47.showPdBackground;
    }
  }, {
    key: "privateDiningURLPath",
    value: function privateDiningURLPath() {
      var _OVERRIDE_SCHEMA$this48;

      return (_OVERRIDE_SCHEMA$this48 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this48 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this48.privateDiningURLPath;
    }
  }, {
    key: "hideBGImageOnAccountScreens",
    value: function hideBGImageOnAccountScreens() {
      var _OVERRIDE_SCHEMA$this49;

      return (_OVERRIDE_SCHEMA$this49 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this49 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this49.hideBGImageOnAccountScreens;
    }
  }, {
    key: "restaurantsThatSupport10Guests",
    value: function restaurantsThatSupport10Guests() {
      var _OVERRIDE_SCHEMA$this50;

      return (_OVERRIDE_SCHEMA$this50 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this50 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this50.restaurantsThatSupport10Guests;
    }
  }, {
    key: "showAdditionalMenuForPD",
    value: function showAdditionalMenuForPD() {
      var _OVERRIDE_SCHEMA$this51;

      return (_OVERRIDE_SCHEMA$this51 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this51 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this51.showAdditionalMenuForPD;
    }
  }, {
    key: "escapeKerrowLocationsFilterForLocationDropdown",
    value: function escapeKerrowLocationsFilterForLocationDropdown() {
      var _OVERRIDE_SCHEMA$this52;

      return (_OVERRIDE_SCHEMA$this52 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this52 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this52.escapeKerrowLocationsFilterForLocationDropdown;
    }
  }, {
    key: "showBackgroundBuildingImage",
    value: function showBackgroundBuildingImage() {
      var _OVERRIDE_SCHEMA$this53;

      return (_OVERRIDE_SCHEMA$this53 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this53 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this53.showBackgroundBuildingImage;
    }
  }, {
    key: "joinEclubMobileSMSUrl",
    value: function joinEclubMobileSMSUrl() {
      var _OVERRIDE_SCHEMA$this54;

      return (_OVERRIDE_SCHEMA$this54 = _OVERRIDE_SCHEMA[this._brand]) === null || _OVERRIDE_SCHEMA$this54 === void 0 ? void 0 : _OVERRIDE_SCHEMA$this54.joinEclubMobileSMSUrl;
    }
  }]);

  return BrandRules;
}();

export { BrandRules as default };